export const EmailingValidation = (formData) => {
    const errors = {};

    // Validate each field
    if (!formData.NotificationEmailFrom.trim()) {
        errors.NotificationEmailFrom = 'This field is required';
    }
    if (!formData.AppPassword.trim()) {
        errors.AppPassword = 'This field is required';
    }

    return errors;
};

